import React from "react";

import { CHART_COLORS } from "app/constants/ChartColors";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";

import { ProgressBar } from "../../ProgressBar/ProgressBar";

export class CompareProgressbar extends React.Component<any, any> {
    private dynamicFilter: any;

    constructor(props: FixmeType) {
        super(props);
        this.dynamicFilter = dynamicFilterFilter();
    }

    render() {
        const { value, row, rowIndex, format, tableOptions, displayNumberLeft = false } = this.props,
            // @ts-ignore FIXME: strict migration - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type — tableOptions.colorSource is any from props
            innerColor = CHART_COLORS[tableOptions.colorSource][rowIndex];
        let key, share, width;

        // to fit all kinds of modules (app analysis/web analysis etc.) e.g: "ShareOfVisits" / "ShareOfDownloads" ...
        for (key in row) {
            if (/ShareOf/.test(key)) {
                share = row[key];
            }
        }
        width = share ? share * 100 : 0;

        return (
            <div className="swTable-progressBar">
                {displayNumberLeft ? (
                    <div className="compare-progress-value value u-alignLeft">{this.dynamicFilter(value, format)}</div>
                ) : null}
                <div className="u-full-width">
                    <ProgressBar
                        width={width}
                        innerColor={innerColor}
                        isCompare={false}
                    />
                </div>
                {!displayNumberLeft ? (
                    <div className="compare-progress-value value u-alignRight">{this.dynamicFilter(value, format)}</div>
                ) : null}
                {this.props.GAVerifiedIcon}
            </div>
        );
    }
}
